import React from 'react';

import { Box } from '@mui/material';

import { buildCloudinaryImageUrl, getCloudinaryImageId } from '~/utils/cloudinaryImage';
import { isRecord } from '~/utils/isRecord';

import { IMAGE_TRANSFORM } from './constants';

export function getImageTitle(value: unknown, fallback: string): string {
  if (!isRecord(value)) {
    return fallback;
  }

  const title = value.title ?? value.name ?? value.filename;
  return typeof title === 'string' && title.trim() ? title.trim() : fallback;
}

export function getImagePreview(value: unknown, alt: string, allowStringImageId = false): React.ReactNode {
  const imageId = getCloudinaryImageId(value, { allowPlainString: allowStringImageId });
  const imageUrl = imageId ? buildCloudinaryImageUrl(imageId, IMAGE_TRANSFORM) : undefined;

  if (!imageUrl) {
    return null;
  }

  return (
    <Box
      component="img"
      src={imageUrl}
      alt={alt}
      sx={{
        aspectRatio: '11 / 7',
        bgcolor: 'grey.200',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        display: 'block',
        objectFit: 'cover',
        width: '100%',
      }}
    />
  );
}
